import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

import PhotoCamera from '@material-ui/icons/PhotoCamera';
export const JitsuCamponentBottomOptions = (props) => {

  var {takephoto, shareVideoToggle, showVideoFlyer} = props;
  var photoVisibility = showVideoFlyer ? 'hidden' : 'visible'

  return <div style={ { position: "absolute", bottom: "0", zIndex: "2", backgroundColor: 'transparent' } } className="d-flex w-100 justify-content-around">
           <Button onClick={ (event) => window.history.back() } className="m-3" style={ { outline: 0, height: '8vh', width: "8vh", border: '1px solid white', backgroundColor: 'transparent' } } variant="fab" aria-label="Add">
             <img style={ { opacity: ".8", zIndex: "3", color: "white", position: 'absolute', height: '8vh' } } src={ `./images/return.png` } />
             <img style={ { opacity: ".7", zIndex: "2", position: 'absolute', height: '6vh' } } src={ `./images/sabers.svg` } />
             <img style={ { opacity: ".7", zIndex: "1", position: 'absolute', height: '6vh' } } src={ `./images/star.png` } />
           </Button>
           <Button onClick={ (event) => takephoto() } className="m-3" style={ { visibility: photoVisibility, outline: 0, height: '8vh', width: "8vh", border: '1px solid white', backgroundColor: 'transparent' } } variant="fab" aria-label="Add">
             <img style={ { opacity: ".8", zIndex: "3", color: "white", position: 'absolute', height: '6vh' } } src={ `./images/photo.png` } />
             <img style={ { zIndex: "2", position: 'absolute', height: '6vh' } } src={ `./images/sabers.svg` } />
             <img style={ { zIndex: "1", position: 'absolute', height: '6vh' } } src={ `./images/star.png` } />
           </Button>
           <Button onClick={ (event) => shareVideoToggle() } className="m-3" style={ { outline: 0, height: '8vh', width: "8vh", border: '1px solid white', backgroundColor: 'transparent' } } variant="fab" aria-label="Add">
             { showVideoFlyer
               ?
               <img style={ { opacity: ".9", zIndex: "3", color: "white", position: 'absolute', height: '7vh' } } src={ `./images/closeVideoStream.png` } />
               :
               <img style={ { opacity: ".8", zIndex: "3", color: "white", position: 'absolute', height: '7vh' } } src={ `./images/videoChat.png` } /> }
             <img style={ { opacity: ".5", zIndex: "2", position: 'absolute', height: '6vh' } } src={ `./images/sabers.svg` } />
             <img style={ { opacity: ".5", zIndex: "1", position: 'absolute', height: '6vh' } } src={ `./images/star.png` } />
           </Button>
         </div>
}


// WEBPACK FOOTER //
// ./src/Components/JitsuCamponent/JitsuCamponentBottomOptions.js